<template>
  <div id="personalBox" class="personalise-warp">
    <div class="personal-tab" v-if="listProduct.length" :class="{'personal-fixed': isFixed}">
      <div class="tab-item" :class="{'active': item.id == curTab}" v-for="item in tabNav" :key="item.id" @click="changTab(item)">
        <h5>{{item.name}}</h5>
        <p>{{item.desc}}</p>
      </div>
      <div class="sub-tab" :class="{'sub-tab-active': isFixed && subNavShow}" v-if="curTab == 5 && subNavShow">
        <span :id="`sub_${item.code}`" v-for="item in subNav" :key="item.code" :class="{'active': item.code == curSubNav}" @click="changeSub(item, $event)">{{item.name}}</span>
      </div>
    </div>
    <div class="btm-category-warp" v-if="!listProduct.length && fetchEnd">
      <div class="category-empty">
        <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/order/card-empty.png" alt="">
      </div>
    </div>
    <div v-else id="waterWarpList" class="waterfull-list" :style="{'padding-top': waterfullPaddingTop}">
      <!-- <div class="fixed-placeholder" v-show="isFixed"></div> -->
      <waterfullList page="home" :pageIndex="curPage" :tabId="curTab" :tabName="curTabName" :subNav="curSubNav" :subName="curSubNavName" :lists="listProduct"/>
    </div>
    <div id="loadScroll" class="loading-text">
      <div v-if="!fetchEnd">加载中...</div>
      <div v-else>{{!listProduct.length ? '没有相关内容' : '没有更多了'}}~</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '../api'
import waterfullList from '@/components/waterfullList'

let cancelToken = () => {}

export default {
  name: 'newBtmProduct',
  components: {
    waterfullList
  },
  data() {
    return {
      curTab: 2,
      curTabName: '精选',
      fetchEnd: false,
      fetching: false,
      curPage: 1,
      pageSize: 10,
      isFixed: false, // 吸顶
      tabNav: [
        { id: 2, name: '精选', desc: '为你推荐' },
        { id: 3, name: '全屋家电', desc: '定制设计' },
        // { id: 4, name: '局改焕新', desc: '老房焕新' },
        // { id: 5, name: '发现更多', desc: '精彩好文' },
      ],
      curSubNav: '',
      curSubNavName: '',
      subNavShow: false,
      subNav: [],
      listProduct: [],

      scrollY: 0, // 滚动距离
      scrollDirection: '', // 滚动方向

      waterWarpTop: 0,
    }
  },
  mounted() {
    this.fetchTabData()
    this.fetchData()
    document.getElementById('app-warp').addEventListener('scroll', this.scrollBindFn)
  },
  beforeDestroy() {
    document.getElementById('app-warp').removeEventListener('scroll', this.scrollBindFn)
    this.IntersectionObserver && this.IntersectionObserver.disconnect()
  },
  computed: {
    ...mapGetters(['accessToken']),
    ...mapGetters({
      location: 'getlocationInfo',
    }),
    waterfullPaddingTop() {
      if (this.curTab === 5 && this.isFixed) {
        return '1.2rem'
      } else if (this.isFixed) {
        return '.58rem'
      } else if (this.curTab === 5 && !this.isFixed) {
        return '.88rem'
      }
      return '0'
    }
  },
  methods: {
    fetchTabData() {
      Api.getWaterfullTab(null, {
        accessToken: this.accessToken
      }).then(({ data }) => {
        let result = data.data
        console.log('waterFullTab==>', data)
        this.subNav = result.classes
        // this.curSubNav = this.subNav[0].code
        // this.curSubNavName = this.subNav[0].name
      })
    },
    changeSub(subItem, ev) {
      this.$util.gioTrackWithVariable('WBSC20007', {
        roughly_classification_id: this.curTab,
        roughly_classification_name: this.curTabName,
        detailed_classification_id: subItem.code,
        detailed_classification_name: subItem.name
      })
      this.curSubNav = subItem.code
      this.curSubNavName = subItem.name
      this.curPage = 1
      this.fetching = false
      this.fetchEnd = false
      this.listProduct = []
      this.fetchData()
      ev.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
      if(this.isFixed){
        let positon = document.getElementById('waterWarpList').offsetTop
        document.getElementById('app-warp').scroll(0, positon)
      }
    },
    changTab(item) {
      this.$util.gioTrackWithVariable('WBSC20006', {
        roughly_classification_id: item.id,
        roughly_classification_name: item.name
      })

      if (item.id === this.curTab) return
      if (item.id === 5) {
        this.subNavShow = true
        this.curSubNav = this.subNav[0]?.code
        this.curSubNavName = this.subNav[0]?.name
        try {
          this.$nextTick(() => { document.getElementById('sub_' + this.curSubNav).scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }) })
        } catch (error) {

        }
      } else {
        this.subNavShow = false
        this.curSubNav = ''
        this.curSubNavName = ''
      }
      this.curTab = item.id
      this.curTabName = item.name
      this.curPage = 1
      this.fetching = false
      this.fetchEnd = false
      this.listProduct = []
      this.fetchData()
      this.$nextTick(() => {
        if(this.isFixed){
          let positon = document.getElementById('waterWarpList').offsetTop
          document.getElementById('app-warp').scroll(0, positon)
        }
      })
    },
    fetchData() {
      cancelToken()
      // console.log('fetchData', this.accessToken)
      if (this.fetching || this.fetchEnd) return
      this.fetching = true;
      let waterfallCode = ''
      if(this.$util.isProdOrPreEnv()){
        waterfallCode = this.curTab == 2 ? 'F0023' : this.curTab === 3 ? 'F0024' : ''
      }else{
        waterfallCode = this.curTab == 2 ? 'F0080' : this.curTab === 3 ? 'F0081' : ''
      }

      // 接口自动分页
      let params = {
        waterfallCode,
        streetCode: this.location.townshipCode,
        provinceId: this.location.provinceId,
        cityId: this.location.cityId,
        streetId: this.location.townshipId,
        firstLoadSign: this.curPage > 1 ? 0 : 1,
        num: this.pageSize
      }
      if (this.curTab === 5) {
        params.bannerId = this.curTab
        params.tagId = this.curSubNav
      }
      Api.getWaterfullList(params, {
        appId: 'MB-UZHSH-0000',
        accountToken: this.accessToken,
        timestamp: new Date().getTime(),
        clientId: this.$util.getGuId(),
        sequenceId: this.$util.randomString(),
        cancelToken: new this.$http.CancelToken(c => {
          cancelToken = c;
        }),
      },this.curTab).then(({ data }) => {
        let result = data.data
        console.log('getWaterfullList==>', result)
        this.fetching = false;
        if (result && result.items && result.items.length) {
          // let arr = result.items.map(item => {
          //   item.classIndexSelect = 'person-prod-page-' + this.curPage // 分页加载时防止重复上报class
          //   return item
          // })
          this.listProduct = this.listProduct.concat(result.items.map(item => {
            item.resourceInfo.price = item.resourceInfo.finalPrice
            return item
          }))
          this.curPage += 1
          // if (result?.items.length < this.pageSize) {
          //   this.fetchEnd = true
          // }
        } else {
          this.fetchEnd = true
        }
      }).catch(() => {
        this.fetchEnd = true
      })
    },
    scrollBindFn(ev) {
      let el = document.getElementById('loadScroll')
      let fixedTop = document.getElementById('waterWarpList') && document.getElementById('waterWarpList').offsetTop

      this.waterWarpTop = document.getElementById('waterWarpList') && document.getElementById('waterWarpList').getBoundingClientRect().top

      if (el && el.getBoundingClientRect().top < window.innerHeight + 200) {
        this.scrollFn('fetch')
      }
      let scrollTop = ev.target.scrollTop
      console.log(scrollTop, fixedTop)
      if (scrollTop >= fixedTop) {
        this.scrollFn('fixed', 1)
      } else {
        this.scrollFn('fixed', 0)
      }

      this.scrollDirection = this.scrollY - scrollTop < 0 ? 'down' : 'up'
      this.scrollY = scrollTop
      if (this.scrollDirection === 'down' && this.isFixed && this.waterWarpTop < 0) {
        this.subNavShow = false
      } else {
        this.subNavShow = true
      }
    },
    scrollFn(type, isFixed) {
      if (type === 'fetch') {
        this.fetchData()
      }
      if (type === 'fixed') {
        this.isFixed = !!isFixed
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.personalise-warp{
  padding-top: .2rem;
}
.personal-tab{
  position: relative;
  display: flex;
  justify-content: space-between;
  .tab-item{
    flex: 1;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 1.1rem;
    h5{
      font-size: .32rem;
      font-weight: bold;
    }
    p{
      font-size: .2rem;
      line-height: .45rem;
      color: #999;
    }
    &.active{
      h5{
        position: relative;
        &::after{
          content: '';
          display: block;
          position: absolute;
          bottom: -.08rem;
          left: 0;
          right: 0;
          height: .12rem;
          background-image: linear-gradient(90deg, #7BB8F4 0%, rgba(255,255,255,0.00) 92%);
          border-radius: .1rem;
        }
      }
    }
  }
  .sub-tab{
    position: absolute;
    top: 1rem;
    left: 0;
    right: 0;
    padding: .2rem .32rem;
    z-index: 5;
    white-space: nowrap;
    overflow-x: auto;
    span{
      margin-right: .24rem;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: .52rem;
      padding: 0 .24rem;
      font-size: .26rem;
      color: #000;
      border-radius: .5rem;
      &:last-child{
        margin-right: 0;
      }
      &.active{
        color: #fff;
        background: $themeSynMain;
      }
    }
  }
}

.sub-tab-active{
  background: #fff;
}

.personal-fixed{
  position: fixed;
  top: 1.68rem;
  left: 0;
  right: 0;
  z-index: 20;
  background: #fff;
  @include max-width;
}

.fixed-placeholder{
  height: 1.1rem;
}

.waterfull-list{
  margin: 0 .32rem;
  box-sizing: border-box;
  min-height: 12rem;
  transition: all .1s linear;
}

.waterfull-fixed{
  padding-top: 2.2rem;
}

.waterfull-padding{
  padding-top: .88rem
}

.waterfull-padding-fixed{
  padding-top: 3rem
}

.loading-text{
  padding: .2rem 0;
  padding-bottom: 1.2rem;
  text-align: center;
  font-size: .24rem;
  color: #969799;
}

.category-empty{
  padding-top: 1rem;
  text-align: center;
  img{
    display: inline-block;
    max-width: 40%;
  }
}
</style>
